import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface NavbarState {
  status: 'idle' | 'loading' | 'failed'
  activeLink: string
};

const initialState: NavbarState = {
  status: 'idle',
  activeLink: '/'
};

export const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    setActiveLink: (state, action: PayloadAction<string>) => {
      state.activeLink = action.payload
    }
  }
});

export const selectActiveLink = (state: RootState) => state.navbar.activeLink;

export const { setActiveLink } = navbarSlice.actions;
export default navbarSlice.reducer;
